import { useMemo } from 'react';

export const useCheckoutStatusColors = (status: string) => {
	const className = useMemo(() => {
		switch (status) {
			case 'queued_up':
				return 'bg-warning-selected text-warning-main';
			case 'in_progress':
				return 'bg-primary-selected text-primary-main';
			case 'payment_pend':
				return 'bg-secondary-selected text-secondary-main';
			case 'completed':
				return 'bg-success-selected text-success-main';
			case 'rejected':
				return 'bg-error-selected text-error-main';
			case 'pending':
				return 'bg-orange-selected text-orange-700';
			default:
				return '';
		}
	}, [status]);

	return className;
};
